import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './form.css';
function RingFieldsList({ className, children }) {
    return _jsx("div", { className: classNames(styles.fieldsList, className), children: children });
}
export default RingFieldsList;
